import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const CompanyLined = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <G fill="#2F3440" clipPath="url(#a)">
      <Path d="M6.83 8.6h1.02c.28 0 .51-.27.51-.6 0-.33-.23-.6-.51-.6H6.83c-.28 0-.51.27-.51.6 0 .33.23.6.51.6ZM10.18 8.6h1.02c.28 0 .51-.27.51-.6 0-.33-.23-.6-.51-.6h-1.02c-.28 0-.51.27-.51.6 0 .33.23.6.51.6ZM6.83 11.48h1.02c.28 0 .51-.27.51-.6 0-.33-.23-.6-.51-.6H6.83c-.28 0-.51.27-.51.6 0 .33.23.6.51.6ZM10.18 11.48h1.02c.28 0 .51-.27.51-.6 0-.33-.23-.6-.51-.6h-1.02c-.28 0-.51.27-.51.6 0 .33.23.6.51.6Z" />
      <Path d="M19.14 8.88 14 8.18V5.97c0-.74-.46-1.38-1.11-1.56L5.81 2.49c-.12-.03-.24-.05-.35-.05v1.3l7.09 1.92c.06.02.15.14.15.31v3.02c0 .05-.03.1-.03.15V20.7h-1.05v-4.61c0-.74-.6-1.33-1.33-1.33H8.07c-.74 0-1.33.6-1.33 1.33v4.61H5.3V4.05c0-.21.13-.31.16-.31v-1.3c-.78 0-1.46.7-1.46 1.61v17.27c0 .38.28.68.62.68h14.54c.46 0 .84-.38.84-.84V9.87c0-.5-.37-.92-.86-.98v-.01ZM10.42 20.7H7.94v-4.61c0-.07.06-.13.13-.13h2.22c.07 0 .13.06.13.13v4.61Zm8.28 0H14V9.49l4.7.64V20.7Z" />
      <Path d="M15.74 12.6h1.2c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6h-1.2c-.33 0-.6.27-.6.6 0 .33.27.6.6.6ZM15.74 15.67h1.2c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6h-1.2c-.33 0-.6.27-.6.6 0 .33.27.6.6.6ZM16.93 17.64h-1.2c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h1.2c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default CompanyLined
